export default __webpack_public_path__ + "/assets/fonts/inter-cyrillic-wght-normal.woff2";